import { i18n } from './localization';
import {
    MAX_NAME_LENGTH,
    MAX_COMMENT_LENGTH,
    MAX_DESCRIPTION_LENGTH,
    MAX_REPORT_NAME_LENGTH,
    MAX_PASSWORD_LENGTH,
    MAX_CALL_NAME_LENGTH,
    MAX_MEMBERS_LIST,
    CARD_ID_LENGTHS,
    CARD_ID_LENGTHS_ARRAY,
    RESERVED_ROLE_NAMES,
    MAX_PHONE_LENGTH,
    MAX_TIMEOUT,
    MIN_TIMEOUT,
    MAX_STAFF_OVERLOAD,
    MIN_STAFF_OVERLOAD,
    USER_TYPES,
} from './constants';

let errors = {};
let forbiddenDeviceNames;
let incorrectDate;
let timeDiffFrom;
let timeDiffTo;
let emptyEmails;
let incorrectTime;

export function errorDisplay(obj, params) {
    for (let i in obj) {
        if (i[0] !== '$' && obj[i] === false) {
            return i18n.t(errors[i], params);
        }
    }
}

export function multipleErrorsDisplay(obj) {
    let errorArr = [];
    for (let i in obj) {
        if (i[0] !== '$' && obj[i] === false) {
            errorArr.push(i18n.t(errors[i]));
        }
    }
    return errorArr;
}

/**
 * Errors for invalid values in add/edit form for staff members
 * @param {Object} obj
 * @param {Object} param
 * @return {Array}
 */
export function customErrorsForStaffMembers(obj, param) {
    let errorArr = [];
    for (let i in obj) {
        if (i[0] !== '$' && obj[i] === false && obj.noPhoneNumberStaff === false) {
            errorArr.push(i18n.t(errors[i]));
        }
        if (i[0] !== '$' && obj[i] === false && obj.noPhoneNumberStaffGroup === false) {
            errorArr.push(
                i18n.t('staff.membersTab.staffMemberIsTheLast', {
                    groups: param.assignedGroupNames.join(', '),
                })
            );
            break;
        }
    }
    return errorArr;
}

// Builtin validators
import numeric from 'vuelidate/lib/validators/numeric';
import minValue from 'vuelidate/lib/validators/minValue';
import maxValue from 'vuelidate/lib/validators/maxValue';

export default {
    beforeCreate() {
        for (let i in this.rules) {
            if (this.rules.hasOwnProperty(i)) {
                errors[i] = 'validators.' + i;
            }
        }
    },

    rules: {
        autoLogoutRange,
        correctMMSS,
        deviceId,
        email,
        emptyAllFields,
        emptyEmails,
        forbidden,
        forbiddenDeviceId,
        forbiddenDeviceNames,
        forbiddenNames,
        forbiddenPassword,
        forbiddenReservedLogins,
        forbiddenStaffLogin,
        forbiddenStaffName,
        incorrectDate,
        incorrectTime,
        isCardIdInUse,
        isCardIdInUseBySuperUser,
        isCardIdInUseByStaffFromAnotherAA,
        isNotEmptyCallId,
        max24Hours,
        maxValue,
        maxValueNotExceeded,
        maximumCallNameLength,
        maximumCardIdLength,
        maximumCommentLength,
        maximumDescriptionLength,
        maximumNameLength,
        maximumPasswordLength,
        maximumPhoneLength,
        maximumReportNameLength,
        membersLimit,
        minValue,
        minimumLength,
        minimumLoginLength,
        needStaffWithNumber,
        noPhoneNumberStaff,
        noPhoneNumberStaffGroup,
        numeric,
        passwordRequired,
        passwordsMatch,
        possibleAssignmentsLevels,
        possibleAssignmentsTypes,
        staffOverloadRange,
        timeDiffFrom,
        timeDiffTo,
        timeFormat,
        timeInterval,
        timeWindow,
        verifyChecksum,
    },
};

export function minimumLoginLength(val, type) {
    return type === USER_TYPES.SYS_ADMIN ? minimumLength(val) : true;
}

export function minimumLength(val) {
    if (val && typeof val !== 'number') {
        val = val.trim();
    }
    return val === null ? false : /^.+$/.test(val);
}

export function maximumNameLength(val) {
    return !val || val.trim().length <= MAX_NAME_LENGTH;
}

export function maximumCommentLength(val) {
    return !val || val.trim().length <= MAX_COMMENT_LENGTH;
}

export function maximumDescriptionLength(val) {
    return !val || val.trim().length <= MAX_DESCRIPTION_LENGTH;
}

export function maximumReportNameLength(val) {
    return !val || val.trim().length <= MAX_REPORT_NAME_LENGTH;
}

export function maximumPhoneLength(val) {
    return !val || val.trim().length <= MAX_PHONE_LENGTH;
}

export function forbidden(val) {
    return !val || /^([^\[\]\\@|\/]+(.\[^\[\]\\@|\/])*)$/.test(val);
}

export function staffOverloadRange(val) {
    return val >= MIN_STAFF_OVERLOAD && val <= MAX_STAFF_OVERLOAD;
}

export function autoLogoutRange(val) {
    return val >= MIN_TIMEOUT && val <= MAX_TIMEOUT;
}

export function timeWindow(val) {
    return !val || /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(val);
}

export function email(emails) {
    return emails.every(email =>
        /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/.test(
            email
        )
    );
}

/**
 * Check time interval in Time window resident profiles
 * @param {Object} obj object of resident profile
 * obj.val: (Number)
 * obj.value: (Object)
 * @return {boolean}
 */
export function timeInterval(obj) {
    let delta;
    let timeWindowFrom = obj.value.time_window_from !== undefined ? obj.value.time_window_from : obj.val;
    let timeWindowTo = obj.value.time_window_to !== undefined ? obj.value.time_window_to : obj.val;
    if (timeWindowFrom && timeWindowTo) {
        if (timeWindowFrom === timeWindowTo) {
            return false;
        }
        let arrFrom = timeWindowFrom.split(':');
        let secondsFrom = arrFrom[0] * 60 * 60 + arrFrom[1] * 60;
        let arrTo = timeWindowTo.split(':');
        let secondsTo = arrTo[0] * 60 * 60 + arrTo[1] * 60;
        if (secondsFrom > secondsTo) {
            delta = 24 * 60 * 60 - secondsFrom + secondsTo;
            return delta <= 23 * 60 * 60 + 1;
        }
        if (secondsFrom < secondsTo) {
            delta = secondsTo - secondsFrom;
            return delta <= 23 * 60 * 60 + 1;
        }
    }
    return true;
}

export function timeFormat(val, rule) {
    switch (rule) {
        case 'HH':
            return !val || /^([0-1]?[0-9]|2[0-4])$/.test(val);
        case 'MM':
        case 'SS':
            return !val || /^([0-5]?[0-9])$/.test(val);
        default:
            return false;
    }
}

export function emptyAllFields(val, rule) {
    let h = rule.HH !== undefined ? rule.HH : val;
    let m = rule.MM !== undefined ? rule.MM : val;
    let s = rule.SS !== undefined ? rule.SS : val;

    h = String(h);
    m = String(m);
    s = String(s);

    return !!h || !!m || !!s;
}

export function max24Hours(val, rule) {
    let h = Number(rule.HH !== undefined ? rule.HH : val);
    let m = Number(rule.MM !== undefined ? rule.MM : val);
    let s = Number(rule.SS !== undefined ? rule.SS : val);
    h = isNaN(h) ? 0 : h;
    m = isNaN(m) ? 0 : m;
    s = isNaN(s) ? 0 : s;

    // convert to seconds and it must be no more than 24 hours
    return h * 60 * 60 + m * 60 + s <= 24 * 60 * 60;
}

export function inUseNames(val, rule) {
    if (val && val.trim()) {
        for (let key in rule) {
            if (rule[key].name.toLowerCase().trim() === val.toLowerCase().trim()) {
                return false;
            }
        }
    }
    return true;
}

export function forbiddenNames(val, rule) {
    if (val.trim()) {
        for (let key in rule) {
            if (
                rule.hasOwnProperty(key) &&
                rule[key].name.toLowerCase().trim() === val.toLowerCase().trim()
            ) {
                return false;
            }
        }
    }
    return true;
}

/**
 * Validate forbidden wireless device id
 * @param {Object} obj object of wireless modules
 * obj.val: (String)
 * obj.isAddForm: (Boolean)
 * obj.value: (Object)
 * obj.list: (Array)
 * @returns {Boolean}
 */
export function forbiddenDeviceId(obj) {
    if (obj.isAddForm) {
        let result = obj.list.find(item => item.wireless_id === obj.val);
        return !result;
    } else if (obj.value.device_type === 41) {
        let oldId = obj.list.find(item => item.name === obj.value.name);
        return obj.val === oldId.wireless_id ? true : !obj.list.find(item => item.wireless_id === obj.val);
    }
    return true;
}

export function deviceId(val) {
    let pattern =
        '^[1-9A-F][0-9A-F]{5}$|' +
        '^[0-9A-F][1-9A-F][0-9A-F]{4}$|' +
        '^[0-9A-F]{2}[1-9A-F][0-9A-F]{3}$|' +
        '^[0-9A-F]{3}[1-9A-F][0-9A-F]{2}$|' +
        '^[0-9A-F]{4}[1-9A-F][0-9A-F]$|' +
        '^[0-9A-F]{5}[1-9A-F]$';
    return !val || !!val.trim().match(pattern);
}

export function forbiddenReservedLogins(val) {
    let login = val.toLowerCase().trim();
    return !RESERVED_ROLE_NAMES.some(item => item.name === login);
}

export function forbiddenStaffLogin(val) {
    return !val || /^([^'"\[\]\\@|\/]+(.\[^'"\[\]\\@|\/])*)$/.test(val);
}

export function forbiddenStaffName(val) {
    return !val || /^([^\[\]\\@|\/+;,]+(.\[^\[\]\\@|\/+;,])*)$/.test(val.trim());
}

export function maximumCardIdLength(val) {
    return !val || CARD_ID_LENGTHS_ARRAY.includes(val.trim().length);
}

export function membersLimit(val) {
    return (
        !val ||
        [...new Set(val.filter(user => !!user.call_id).map(item => item.call_id))].length <= MAX_MEMBERS_LIST
    );
}

/**
 * Validate staff group (return true if it is valid).
 *  The group is valid when it is not assigned,
 *  or it is assigned and contains assignable user with phone number.
 * @param {Object} staffGroup
 * staffGroup.value: (Object)
 * staffGroup.isAssigned {boolean}
 * @return {boolean} true if the group is valid
 */
export function needStaffWithNumber(staffGroup) {
    return (
        !staffGroup.isAssigned ||
        staffGroup.value.users.some(staffMember => staffMember.assignable && staffMember.call_id)
    );
}

/**
 * Validate phone number for staff if exists
 * @param {Object} obj
 * obj.val: (String)
 * obj.isAssigned {boolean}
 * @return {boolean}
 */
export function noPhoneNumberStaff(obj) {
    return !!obj.val || !obj.isAssigned;
}

/**
 * Validate phone number for staff group if exists
 * @param {Object} obj
 * obj.val: (Number)
 * obj.assignedGroupNames {Array}
 * @return {boolean}
 */
export function noPhoneNumberStaffGroup(obj) {
    return !!obj.val || obj.assignedGroupNames.length === 0;
}

/**
 * Validate password matched
 * @param {Object} obj
 * obj.val: (String)
 * obj.value {Object}
 * @return {boolean}
 */
export function passwordsMatch(obj) {
    let rule =
        obj.value.login_name.trim() && obj.value.password ? obj.value.password : obj.value.verifyPassword;
    return obj.val.trim() === rule.trim();
}

/**
 * Check password is required or not
 * @param {Object} obj
 * obj.needToChangePwd: (boolean)
 * obj.value {Object}
 * obj.val: (String)
 * @return {boolean}
 */
export function passwordRequired(obj) {
    return !(obj.needToChangePwd && obj.value.login_name.trim() && !/^.+$/.test(obj.val));
}

/**
 * Validate password length
 * @param {Object} obj
 * obj.val: (String)
 * obj.value {Object}
 * @return {boolean}
 */
export function maximumPasswordLength(obj) {
    return !obj.val || obj.val.length <= MAX_PASSWORD_LENGTH || !obj.value.login_name.trim();
}

/**
 * Validate password if is forbidden
 * @param {Object} obj
 * obj.val: (String)
 * obj.value {Object}
 * @return {boolean}
 */
export function forbiddenPassword(obj) {
    return !(!forbidden(obj.val) && obj.value.login_name.trim());
}

export function verifyChecksum(val) {
    if (val) {
        switch (val.trim().length) {
            case CARD_ID_LENGTHS.MIFARE_CLASSIC: {
                val = '0000000000' + val.trim();
                val = val.substring(val.length - 10);
                let code = 0;
                for (let c = 0; c < 5; c++) {
                    let hexbyte = val.substring(2 * c, 2 * c + 2);
                    if (Number.parseInt(hexbyte, 16)) {
                        code = code ^ Number.parseInt(hexbyte, 16);
                    } else {
                        return false;
                    }
                }
                return code === 0;
            }
            case CARD_ID_LENGTHS.WIEGAND:
            case CARD_ID_LENGTHS.MIFARE_ULTRALIGHT_DESFIRE: {
                // No CRC-rule. Only check if it is a hexadecimal string
                let reg = /^[0-9A-Fa-f]+$/;
                return reg.test(val.trim());
            }
            default: {
                return false;
            }
        }
    }
    return true;
}

export function isCardIdInUse(obj) {
    let { cardIdUsed, staff } = obj;
    return !(cardIdUsed && staff);
}

export function isCardIdInUseBySuperUser(obj) {
    let { cardIdUsed, staff } = obj;
    return !(cardIdUsed && staff && staff.type === USER_TYPES.SUPER_USER);
}

export function isCardIdInUseByStaffFromAnotherAA(obj) {
    let { staff } = obj;

    if (staff) {
        return staff.fromCurrentAA;
    }

    return true;
}

export function maximumCallNameLength(val) {
    return !val || val.trim().length <= MAX_CALL_NAME_LENGTH;
}

export function possibleAssignmentsTypes(val) {
    return !val || /^[012]$/.test(val);
}

export function possibleAssignmentsLevels(val) {
    return !val || /^[01]$/.test(val);
}

export function correctMMSS(val, hour) {
    return (hour && val === '60:00') || /^([0-5][0-9]):([0-5][0-9])$/.test(val);
}

export function correctHHMM(val) {
    return /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/.test(val);
}

export function maxValueNotExceeded(val, second, max) {
    let validFirst = correctMMSS(val, max === 3600);
    let validSecond = correctMMSS(second, max === 3600);

    if (validFirst && validSecond) {
        let time1 = val.split(':');
        let time2 = second.split(':');
        return max >= Number(time1[0]) * 60 + Number(time1[1]) + Number(time2[0]) * 60 + Number(time2[1]);
    }

    return true;
}

export function isNotEmptyCallId(val) {
    return !!val && val.length > 0;
}
